import { React, useState, useEffect } from "react";
import "./index.css";
import usbimages from "./img/sims.jpg";
import tsimages from "./img/dsimg.jpg";
import logoutimg from "./img/logout.png";
import image from "./img/switch.png";
import imagebk from "./img/back.png";
import axios from "axios";
import { SAVEAUDITLOGS } from "../../Pages/AppConstant";
import imagebat from  "./img/batteryanalytics.png";


function PDDashboard() {
  useEffect(() => {
    getsession();
    // fetchapprovaldata();
  }, []);
  const getsession = () => {
    if (localStorage.getItem("sessions") !== "isactive") {
      window.location.href = "/";
    }
  };
  const redirectToLogin = () => {
    window.location.href = "/login";
  };
  const redirectusbactivation = () => {
    // window.location.href = "/simulations"
    // window.open("http://10.14.14.79:8501/", "_blank");
    window.open("http://10.14.12.97:8501/", "_blank");
  };
  const thermald = () => {
    if(localStorage.getItem("empid")==="HLF_0015"){
       window.open(
      "http://oneclick.switchmobilityev.com/analytics/",
      "_blank"
    );
    }
    const formData = new FormData();
    formData.append("employee_id", localStorage.getItem("empid"));

    axios
      .post(SAVEAUDITLOGS, formData, {})
      .then((response) => {
      window.open(
      "http://oneclick.switchmobilityev.com/analytics/",
      "_blank"
    );
      })
      .catch((error) => {
        console.error(
          "Error saving audit log:",
          error.response?.data || error.message
        );
      });

    // window.location.href = "/thermal"
  

    // var listdata= localStorage.getItem('empid')
    // if(listdata==="300645" || listdata==="300381"  || listdata==="300169"){
    // }
  };
  const redirectTodashboard = () => {
    window.location.href = "/landingPage";
  };
 const redirectbattery=()=>{       
        // window.location.href = "/thermal"
        window.open('https://d123fy7nh94zx3.cloudfront.net/', '_blank')

        // var listdata= localStorage.getItem('empid')
        // if(listdata==="300645" || listdata==="300381"  || listdata==="300169"){
        // }
    }
  return (
    <>
      <div className="">
        {/* <Tableau/> */}
        <div className="switch_new">
          <img
            className="switch-back"
            onClick={redirectTodashboard}
            src={imagebk}
          />
          <img className="switch-img-new" src={image} />
          <img
            className="logout-img-new"
            title="Logout"
            onClick={redirectToLogin}
            src={logoutimg}
          />
        </div>
        <br />
        <br />

        <div className="container ">
          <div className="row">
            <div className="col-md-2 ">
              <div class="single-menu-item ">
                <div
                  class="module-icon-wrapper cursordesign"
                  onClick={thermald}
                >
                  <img className="img-design-dash" src={tsimages} />
                </div>
                <p>Dashboard</p>
              </div>
            </div>
            <div className="col-md-2 ">
              <div class="single-menu-item ">
                <div
                  class="module-icon-wrapper cursordesign"
                  onClick={redirectusbactivation}
                >
                  <img className="img-design-sims" src={usbimages} />
                </div>
                <p>Simulations</p>
                </div>
                </div>
                <div className="col-md-2 " >
                <div class="single-menu-item " >
                <div class="module-icon-wrapper cursordesign" onClick={redirectbattery}>
                <img className="img-design-sims"  src={imagebat}/>
                </div>
                <p>Battery Analytics</p>
                </div>
                </div>
                </div>
                </div>
            </div>
        
    </>
  );
}
export default PDDashboard;
